import { render, staticRenderFns } from "./CreateArtist.vue?vue&type=template&id=0bcce27e&scoped=true"
import script from "./CreateArtist.vue?vue&type=script&lang=js"
export * from "./CreateArtist.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=0bcce27e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcce27e",
  null
  
)

export default component.exports